<template>
    <div class="board">
        <el-row :gutter="20" style="margin-left:0;margin-right:0;">
            <div>
                <el-col :span="20">
                    <h3 id="pageTitle">首页</h3>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content">
                        <full-screen-btn :hideElIds="hideElIds"></full-screen-btn>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content">
                        <el-button @click="jumpToOldIndexHandler" size="small">返回原首页</el-button>
                    </div>
                </el-col>
            </div>
        </el-row>
        <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
            <el-tab-pane
                    :disabled="tabDisable"
                    v-for="(item, index) in tabs"
                    :key="item.name"
                    :label="item.title"
                    :name="item.name"
                    :id="item.id">
                <component :is="item.content" :ref="item.name"></component>
            </el-tab-pane>
        </el-tabs>

        <back-to-top :el="fullScreenEl">
        </back-to-top>

    </div>
</template>

<script>
    import FullScreenBtn from "@/components/common/fullScreenBtn";
    import BossBoard from "@/views/board/boss/bossBoard"
    import OperationBoard from "@/views/board/operation/operation-board-index"
    import BackToTop from '@/components/common/BackToTop'

    export default {
        name: "index",

        data() {
            return {
                activeTab: '',

                tabDisable: true,

                tabs: [{
                    title: '领导视图',
                    name: 'tab_boss',
                    id: 'tab_boss',
                    content: BossBoard
                }, {
                    title: '运维视图',
                    name: 'tab_operation',
                    id: 'tab_operation',
                    content: OperationBoard,
                }],

                hideElIds: ['pageTitle'],    //全屏后需要隐藏的组件id

                //TAB权限控制
                visible_bossBoard: true,
                visible_operationBoard: true,
                BOSSBOARD_PERMISSION: 'tab.board.bossBoard',
                OPERATIONBOARD_PERMISSION: 'tab.board.operationBoard',

                fullScreenEl: document.getElementById('globalBody'),    //需要全屏的组件id
            }
        },

        components: {
            FullScreenBtn,
            BossBoard,
            OperationBoard,
            BackToTop,
        },

        methods: {
            handle_tab_click(tab, event) {
                this.activeTab = tab.name;
                if (tab.name == 'tab_boss') {

                    this.$refs['tab_boss'][0].$refs.pueSituation.activeName = 'second';
                    this.$refs['tab_boss'][0].$refs.pueSituation.handleClick('tab');

                    this.$refs['tab_boss'][0].$refs.pueSituation.activeName = 'first';
                    this.$refs['tab_boss'][0].$refs.pueSituation.handleClick('tab');

                }
            },

            removeTab(targetId) {
                this.tabs.forEach((t, index) => {
                    if (t.id == targetId) {
                        let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                        if (nextTab) {
                            this.activeTab = nextTab.id;
                        }
                    }
                });
                this.tabs = this.tabs.filter(tab => tab.id !== targetId);
            },

            jumpToOldIndexHandler() {
                window.location.href = "index";
            },
        },

        created() {
            this.visible_bossBoard = this.hasPermission(this.BOSSBOARD_PERMISSION);
            this.visible_operationBoard = this.hasPermission(this.OPERATIONBOARD_PERMISSION);
        },

        mounted() {
            setTimeout(() => {
                this.tabDisable = false;
            }, 1000);

            if (this.visible_bossBoard == true && this.visible_operationBoard == true) {
                this.activeTab = this.tabs[0].name;
            } else if (this.visible_bossBoard == true && this.visible_operationBoard == false) {
                this.removeTab('tab_operation');
            } else if (this.visible_bossBoard == false && this.visible_operationBoard == true) {
                this.removeTab('tab_boss');
            }
        },

    }
</script>

<style scoped>

</style>
